let confirmHandler = null;

export function setConfirmHandler(handler) {
    confirmHandler = handler;
}

export function confirm(message) {
    if (confirmHandler) {
        return confirmHandler(message);
    }

    return Promise.resolve(window.confirm(message));
}

export default {
    setConfirmHandler,
    confirm,
};
